import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import CustomSelect from "./CustomSelect";
import {
  getMarcas,
  getVehiculos,
  getModelos,
  getFamilias,
  getProductos,
} from "../repository";

const SearchByMaker = ({actualizarproductos}) => {
  const [, setStatus] = useState(null);
  const [idMarca, setIdMarca] = useState(0);
  const [idVehiculo, setIdVehiculo] = useState(0);
  const [idModelo, setIdModelo] = useState(0);
  const [idFamilia, setIdFamilia] = useState(-1);
  const [marcas, setMarcas] = useState([]);
  const [vehiculos, setVehiculos] = useState([]);
  const [modelos, setModelos] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [, setProductos] = useState([]);
  const [loading, setLoading] = useState(0);
  const [errors, setErrors] = useState({});

  // Toast configuration
  const Toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
  });

  useEffect(() => {
    obtieneMarcas();
  }, []);

  // Handler para Marca
  const handleMarcaChange = (selectedValue) => {
    const value = parseInt(selectedValue) || 0;
    actualizarproductos([]);
    setErrors({});
    setIdMarca(value);
    setIdVehiculo(0);
    setVehiculos([]);
    setIdModelo(0);
    setModelos([]);
    setIdFamilia(-1);
    setFamilias([]);
    setProductos([]);
    setStatus(null);
    if (value > 0) {
      obtieneVehiculos(value);
    }
  };

  // Handler para Vehiculo
  const handleVehiculoChange = (selectedValue) => {
    const value = parseInt(selectedValue) || 0;
    actualizarproductos([]);
    setErrors({});
    setIdVehiculo(value);
    setIdModelo(0);
    setModelos([]);
    setIdFamilia(-1);
    setFamilias([]);
    setProductos([]);
    setStatus(null);
    if (value > 0) {
      obtieneModelos(value);
      obtieneFamilias(0, 0);
    }
  };

  // Handler para Modelo
  const handleModeloChange = (selectedValue) => {
    actualizarproductos([]);
    setErrors({});
    setIdModelo(selectedValue);
    setIdFamilia(-1);
    setFamilias([]);
    setProductos([]);
    setStatus(null);
    if (selectedValue && selectedValue !== 0 && selectedValue !== "0") {
      obtieneFamilias(idVehiculo, selectedValue);
    }
  };

  // Handler para Familia
  const handleFamiliaChange = (selectedValue) => {
    const value = parseInt(selectedValue);
    actualizarproductos([]);
    setErrors({});
    setIdFamilia(value);
    setProductos([]);
    setStatus(null);
  };

  const obtieneMarcas = () => {
    getMarcas()
      .then((response) => {
        if (response.status === "success") {
          var items = response.result.map((item) => {
            return { value: item.idMarca, text: item.Marca };
          });
          setMarcas([{ value: 0, text: "Seleccione" }].concat(items));
        } else {
          Swal.fire({
            text: "Error al obtener la información de marcas.",
            icon: "error",
            confirmButtonColor: "#f7a209",
          });
        }
      })
      .catch(() =>
        Swal.fire({
          text: "Error al obtener la información de marcas.",
          icon: "error",
          confirmButtonColor: "#f7a209",
        })
      );
  };

  const obtieneVehiculos = (idMarca) => {
    getVehiculos(idMarca)
      .then((response) => {
        if (response.status === "success") {
          var items = response.result.map((item) => {
            return { value: item.idTipoVehiculo, text: item.TipoVehiculo };
          });
          setVehiculos(
            [{ value: 0, text: items.length > 0 ? "Seleccione" : "---" }].concat(items)
          );
        } else {
          Swal.fire({
            text: "Error al obtener la información de vehículos.",
            icon: "error",
            confirmButtonColor: "#f7a209",
          });
        }
      })
      .catch(() =>
        Swal.fire({
          text: "Error al obtener la información de vehículos.",
          icon: "error",
          confirmButtonColor: "#f7a209",
        })
      );
  };

  const obtieneModelos = (idVehiculo) => {
    getModelos(idVehiculo)
      .then((response) => {
        if (response.status === "success") {
          var items = response.result.map((item) => {
            return { value: item.Modelo, text: item.Modelo };
          });
          setModelos(
            [{ value: 0, text: items.length > 0 ? "Seleccione" : "---" }].concat(items)
          );
        } else {
          Swal.fire({
            text: "Error al obtener la información de modelos.",
            icon: "error",
            confirmButtonColor: "#f7a209",
          });
        }
      })
      .catch(() =>
        Swal.fire({
          text: "Error al obtener la información de modelos.",
          icon: "error",
          confirmButtonColor: "#f7a209",
        })
      );
  };

  const obtieneFamilias = (idVehiculo, idModelo) => {
    getFamilias(idVehiculo, idModelo)
      .then((response) => {
        if (response.status === "success") {
          var items = [];
          if (idVehiculo > 0 && idModelo && idModelo !== "0") {
            items = response.result.map((item) => {
              return { value: item.idFamilia, text: item.Familia };
            });
          }
          setFamilias(
            [{ value: -1, text: items.length > 0 ? "Seleccione" : "---" }].concat(items)
          );
        } else {
          Swal.fire({
            text: "Error al obtener la información de familias.",
            icon: "error",
            confirmButtonColor: "#f7a209",
          });
        }
      })
      .catch(() =>
        Swal.fire({
          text: "Error al obtener la información de familias.",
          icon: "error",
          confirmButtonColor: "#f7a209",
        })
      );
  };

  const search = (e) => {
    e.preventDefault();
    setProductos([]);
    setStatus(null);

    // Validación de campos requeridos
    const newErrors = {};
    if (!idMarca || idMarca === 0) newErrors.idMarca = true;
    if (!idVehiculo || idVehiculo === 0) newErrors.idVehiculo = true;
    if (!idModelo || idModelo === 0 || idModelo === "0") newErrors.idModelo = true;
    if (idFamilia === -1 || idFamilia === null || idFamilia === undefined) newErrors.idFamilia = true;

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      Toast.fire({
        icon: "warning",
        text: "Selecciona todas las opciones",
      });
      return;
    }

    setLoading(1);
    setErrors({});

    getProductos(idVehiculo, idFamilia, idModelo)
      .then((response) => {
        if (response.status === "success") {
          setStatus("success");
          setProductos(response.result);
          actualizarproductos(response.result);
          setLoading(0);
        } else {
          setLoading(0);
          Swal.fire({
            text: "Error al obtener la información.",
            icon: "error",
            confirmButtonColor: "#f7a209",
          });
        }
      })
      .catch(() => {
        setLoading(0);
        Swal.fire({
          text: "Error al obtener la información.",
          icon: "error",
          confirmButtonColor: "#f7a209",
        });
      });
  };

  return (
    <div>
      {/* CONTENT */}
      <section id="searchContent" className="mt-1 mb-1">
        <form onSubmit={search}>
          <div className="container">
            <div className="row mt-0 align-items-end">
              <div className="col-12 col-sm-6 col-md mb-2">
                <h6>Marca:</h6>
                <CustomSelect
                  name="idMarca"
                  value={idMarca}
                  options={marcas}
                  onChange={handleMarcaChange}
                  placeholder="Seleccione"
                  hasError={errors.idMarca}
                />
              </div>
              <div className="col-12 col-sm-6 col-md mb-2">
                <h6>Vehículo:</h6>
                <CustomSelect
                  name="idVehiculo"
                  value={idVehiculo}
                  options={vehiculos}
                  onChange={handleVehiculoChange}
                  placeholder="Seleccione"
                  disabled={!idMarca || idMarca === 0}
                  hasError={errors.idVehiculo}
                />
              </div>
              <div className="col-12 col-sm-6 col-md mb-2">
                <h6>Modelo:</h6>
                <CustomSelect
                  name="idModelo"
                  value={idModelo}
                  options={modelos}
                  onChange={handleModeloChange}
                  placeholder="Seleccione"
                  disabled={!idVehiculo || idVehiculo === 0}
                  hasError={errors.idModelo}
                />
              </div>
              <div className="col-12 col-sm-6 col-md mb-2">
                <h6>Familia:</h6>
                <CustomSelect
                  name="idFamilia"
                  value={idFamilia}
                  options={familias}
                  onChange={handleFamiliaChange}
                  placeholder="Seleccione"
                  disabled={!idModelo || idModelo === 0 || idModelo === "0"}
                  hasError={errors.idFamilia}
                />
              </div>
              <div className="col-12 col-sm-6 col-md-auto mb-2">
                <button className="btn btn-secondary w-100" type="submit">
                  <i className="fa fa-search mr-1"></i>Buscar
                </button>
              </div>
            </div>
            {loading === 1 && (
              <div className="text-center mb-3 mt-3">
                <h6>Buscando...</h6>
                <div
                  className="spinner-border text-warning"
                  role="status"
                  aria-hidden="true"
                ></div>
              </div>
            )}
          </div>
        </form>
      </section>
    </div>
  );
};

export default SearchByMaker;
